import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";

export const profileEntrySchema = Joi.object({
  name: Joi.string().required().messages({
    "string.empty": "Name is required.",
  }),
  email: Joi.string()
    .email({ tlds: { allow: ["com"] } })
    .required()
    .messages({
      "string.empty": "Email Is Required",
      "string.email": "Enter a Valid Email Address",
    }),
  speciality: Joi.string().required().messages({
    "string.empty": "Speciality is required.",
  }),
  mobileNo: Joi.string()
    .required()
    .min(10)
    .required()
    .regex(/^[0-9]+$/)
    .messages({
      "string.empty": "Mobile number is required.",
      "string.min": "Please enter a valid contact number.",
    }),
  experience: Joi.number().required().messages({
    "number.base": "Experience is required",
  }),
  biography: Joi.string().required().messages({
    "string.empty": "Biography is required.",
  }),
  location_url: Joi.string().required().messages({
    "string.empty": "Location is required.",
  }),
  working_time: Joi.string().required().messages({
    "string.empty": "Working Time is required.",
  }),
});

export function useProfileForm({ existingImageUrl }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(1);
  const [Image, setImage] = useState(existingImageUrl);
  const handleFileChange = useCallback((img) => {
    setImage(img);
  }, []);

  const profileUpdate = useCallback(
    async ({
      id,
      name,
      speciality,
      experience,
      biography,
      location_url,
      working_time,
      email,
      mobileNo,
    }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      const image_url = [];

      try {
        dispatch(showPageLoader());

        if (existingImageUrl !== Image) {
          const form = new FormData();
          form.append("file", Image);
          const image_response = await Api.post2(
            {
              url: Urls.imageAdd(),
              data: form,
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            },
            []
          );
          image_url.push(image_response?.data[0]?.url);
        }
        const { data } = await apiPost({
          url: Urls.doctorUpdate(),
          data: {
            id: id,
            name: name,
            email_id: email,
            mobile_no: mobileNo,
            image_url: image_url.length > 0 ? image_url[0] : Image?.url,
            speciality: speciality,
            experience: experience,
            biography: biography,
            location_url: location_url,
            working_time: working_time,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data?.id) === 36) {
          enqueueSnackbar("Profile Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading, Image]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    profileEntrySchema,
    handleStatusComboChange,
    profileUpdate,
    handleFileChange,
  };
}
